import { memo } from 'react';

import { CDN_BASE_EDUZZ_URL } from 'settings';
import { IBannerAnnouncement } from 'types/interfaces';

import { BannerImage, Container } from './styles';

const BannerAnnouncement: React.FC<IBannerAnnouncement> = ({ link, ...props }) => {
  if (link) {
    return (
      <Container>
        <a href={link} target='_blank' rel='noopener noreferrer'>
          <Image {...props} />
        </a>
      </Container>
    );
  }

  return (
    <Container>
      <Image {...props} />
    </Container>
  );
};

const Image: React.FC<IBannerAnnouncement> = ({ alternative, large, medium, short }) => {
  return (
    <picture>
      {short ? <source media='(max-width: 430px)' srcSet={`${CDN_BASE_EDUZZ_URL}${short}`} /> : null}
      {medium ? <source media='(max-width: 900px)' srcSet={`${CDN_BASE_EDUZZ_URL}${medium}`} /> : null}

      <BannerImage src={`${CDN_BASE_EDUZZ_URL}${large}`} alt={alternative} />
    </picture>
  );
};

export default memo(BannerAnnouncement);
